"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GraphError } from '@autoguru/relay/GraphError';
import { buildLogContext } from '../lib';
export const logException = (error, contexts, agent) => {
  if (process.env.NODE_ENV !== "production") console.error({
    error
  });
  const customAttributes = _objectSpread({
    graphqlErrors: error instanceof GraphError ? error.graphqlErrors : [].map(i => {
      var _i$path$join, _i$path;
      return `${i.message}@${(_i$path$join = (_i$path = i.path) === null || _i$path === void 0 ? void 0 : _i$path.join('.')) !== null && _i$path$join !== void 0 ? _i$path$join : 'na'}`;
    }).join('\n'),
    errorMessage: error.message
  }, buildLogContext(contexts));
  if (agent) {
    agent.noticeError(error, customAttributes);
  }
};